import React, { useRef, useState } from "react";
import { login } from "../../Redux/Actions/Auth";
import { setLoader } from "../../Redux/Actions/Loader";
import { handleResponse } from "../../utils/Notification";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import "./login.css";

const Login = () => {
  const [loginData, setLoginData] = useState({ user: "", password: "" });
  const loading = useSelector((state) => state.loader.loading);
  const [submitting, setSubmitting] = useState(false);
  const submissionLock = useRef(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const handleChange = (event) => {
    setLoginData((previous) => ({
      ...previous,
      [event.target.name]: event.target.value,
    }));
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    if (submissionLock.current) return;
    submissionLock.current = true;
    setSubmitting(true);
    dispatch(setLoader(true));
    try {
      const response = await dispatch(
        login({ user: loginData.user, password: loginData.password })
      );
      handleResponse(response);
      if (response && response.success) {
        // Finish loading before leaving the login page.
        dispatch(setLoader(false));
        setSubmitting(false);
        submissionLock.current = false;
        history.push("/");
        return;
      }
    } catch (error) {
      handleResponse({
        success: false,
        message: error && error.message ? error.message : "Sign in failed. Please try again.",
      });
    } finally {
      if (submissionLock.current) {
        dispatch(setLoader(false));
        setSubmitting(false);
        submissionLock.current = false;
      }
    }
  };

  return (
    <main className="ds-login-page">
      <div className="ds-login-layout">
        <section className="ds-login-brand" aria-label="DriveShop Mobile">
          <h1>Fleet Management System</h1>
        </section>

        <section className="ds-login-panel">
          <div className="ds-login-panel__heading">
            <h2>Sign in</h2>
            <p>Enter your DriveShop credentials to continue.</p>
          </div>
          <form className="ds-login-form" onSubmit={handleLogin}>
            <label htmlFor="ds-login-user">Username</label>
            <input
              id="ds-login-user"
              type="text"
              name="user"
              value={loginData.user}
              onChange={handleChange}
              autoComplete="username"
              autoCapitalize="none"
              spellCheck={false}
              required
            />
            <label htmlFor="ds-login-password">Password</label>
            <input
              id="ds-login-password"
              type="password"
              name="password"
              value={loginData.password}
              onChange={handleChange}
              autoComplete="current-password"
              required
            />
            <button type="submit" disabled={loading || submitting}>
              {loading || submitting ? "Signing in..." : "Sign in"}
            </button>
          </form>
          <p className="ds-login-panel__help">Need help accessing DriveShop Mobile? Contact your FMS administrator.</p>
        </section>
      </div>
    </main>
  );
};

export default Login;
